import React from 'react'
export default function Footer({ profile, lang }) {
  return (
    <footer>
      <div className="container">
        <span>
          © {new Date().getFullYear()} {profile.name}
        </span>
        <span>
          {lang === 'en'
            ? 'Systems Engineer · Senior Full-Stack Developer'
            : 'Ingeniero en Sistemas · Desarrollador Full-Stack Senior'}
        </span>
        <a href={profile.linkedin} target="_blank" rel="noreferrer">
          LinkedIn ↗
        </a>
      </div>
    </footer>
  )
}
